<div class="mb-3" *ngIf="question && !isHidden">
  <div [class]="questionClass" [class.required]="isFieldRequired"
    *ngIf="!noQuestionText && question.type_id!=='HEADER' && question.type_id!=='PARAGRAPH'"
    [innerHTML]="sanitizedText">
  </div>
  <div *ngIf="question.type_id==='TF'">
    <select name="answer_{{nameScope}}{{question.id}}" class="form-control" bkInput [(ngModel)]="answers[question.id]" [disabled]="disabled"
      [required]="isFieldRequired">
      <option [ngValue]="value" *ngFor="let value of ['', 'True', 'False']">{{value}}</option>
    </select>
  </div>
  <div *ngIf="question.type_id==='YN' || question.type_id==='food_served' || question.type_id==='collaborate'">
    <div class="form-check" *ngFor="let value of question.na ? ['Yes', 'No', ''] : ['Yes', 'No'];index as i">
      <input type="radio" class="form-check-input" name="answer_{{nameScope}}{{question.id}}" [value]="value"
        [(ngModel)]="answers[question.id]" id="answer_{{nameScope}}{{question.id}}_{{i}}" [required]="isFieldRequired">
      <label class="form-check-label" for="answer_{{nameScope}}{{question.id}}_{{i}}"> {{value === '' ? 'N/A' : value}}</label>
    </div>
  </div>
  <div *ngIf="question.type_id==='CHECKBOX'">
    <div class="form-check">
      <input type="checkbox" class="form-check-input" name="answer_{{nameScope}}{{question.id}}" value="true"
        [(ngModel)]="answers[question.id]">
      <label class="form-check-label" for="answer_{{nameScope}}{{question.id}}"></label>
    </div>
  </div>
  <div *ngIf="question.type_id==='MEAL_OPT_OUT'">
    <div class="form-check">
      <input type="checkbox" class="form-check-input" name="answer_{{nameScope}}{{question.id}}" value="true"
        [(ngModel)]="answers[question.id]">
      <label class="form-check-label" for="answer_{{nameScope}}{{question.id}}"></label>
    </div>
  </div>
  <div *ngIf="question.type_id==='RATING'">
    <rating [(ngModel)]="answers[question.id]" max="5"></rating>&nbsp;&nbsp;
    <input type="radio" *ngIf="question.na" class="form-check-input" name="answer_{{nameScope}}{{question.id}}" [(ngModel)]="answers[question.id]" id="answer_{{nameScope}}{{question.id}}" [value]="'-1'">
    <label class="form-check-label" *ngIf="question.na" for="answer_{{nameScope}}{{question.id}}">&nbsp;&nbsp;N/A</label>
  </div>
  <div *ngIf="question.type_id==='COMMENTS' || question.type_id==='TEXT_AREA'">
    <textarea rows="4" cols="60" name="answer_{{nameScope}}{{question.id}}" class="form-control" bkInput
      [(ngModel)]="answers[question.id]" [required]="isFieldRequired"></textarea>
  </div>
  <div *ngIf="question.type_id==='TEXT_FIELD'">
    <input type="text" name="answer_{{nameScope}}{{question.id}}" class="form-control" bkInput [(ngModel)]="answers[question.id]"
      [required]="isFieldRequired">
  </div>
  <div *ngIf="question.type_id==='PHONE_NUMBER'">
    <app-phone-input name="answer_{{nameScope}}{{question.id}}" [(ngModel)]="answers[question.id]"
      [required]="isFieldRequired"></app-phone-input>
  </div>
  <div *ngIf="question.type_id==='EMAIL'">
    <input type="email" name="answer_{{nameScope}}{{question.id}}" class="form-control"
      [(ngModel)]="answers[question.id]" [required]="isFieldRequired" email #emailAnswer="ngModel">
    <div *ngIf="emailAnswer.errors?.email && (emailAnswer.dirty || emailAnswer.touched)" class="invalid-feedback">
      <span>Please input a valid email address.</span>
    </div>
  </div>
  <div *ngIf="question.type_id==='MULTIPLE_RADIO'">
    <ng-template ngFor let-value let-i="index" [ngForOf]='choices'>
      <div class="form-check" *ngIf='value'>
        <input type="radio" class="form-check-input" name="answer_{{nameScope}}{{question.id}}_{{i}}" [value]="value"
          [(ngModel)]="answers[question.id]" id="answer_{{nameScope}}{{question.id}}_{{i}}" [disabled]="disabled"
          [required]="isFieldRequired">
        <label class="form-check-label" for="answer_{{nameScope}}{{question.id}}_{{i}}"> {{value}}</label>
      </div>
    </ng-template>
  </div>
  <div *ngIf="question.type_id==='MULTIPLE_CHECK'">
    <ng-select [items]='choices' [multiple]="true" [(ngModel)]="answers[question.id]">
      <ng-template ng-option-tmp let-item="item" let-index="index">
        <input type="checkbox" [ngModel]="item.selected" name="answer_{{nameScope}}{{question.id}}_{{index}}" [disabled]="disabled">
        {{item}}
      </ng-template>
    </ng-select>
  </div>
  <div *ngIf="question.type_id==='DROPDOWN'">
    <select name="answer_{{nameScope}}{{question.id}}" class="form-control" bkInput [(ngModel)]="answers[question.id]"
      [required]="isFieldRequired">
      <option [ngValue]="value" *ngFor='let value of choices'>{{value}}</option>
    </select>
  </div>
  <div *ngIf="question.type_id==='SIGNATURE'">
    <div fxLayout="row">
      <button type="button" (click)="signatureField.clear()" [disabled]="!answers[question.id]">Clear</button>
    </div>
    <div fxLayout="row">
      <app-signature-field [(ngModel)]="answers[question.id]"></app-signature-field>
    </div>
  </div>
  <div *ngIf="question.type_id==='NUMBER' || question.type_id==='speaker_count'">
    <input type="text" name="answer_{{nameScope}}{{question.id}}" class="form-control" bkInput [(ngModel)]="answers[question.id]"
      [required]="isFieldRequired">
  </div>
  <div class="{{questionHeaderClass}} b-none m-t-10" *ngIf="question.type_id==='HEADER'" [innerHTML]="sanitizedText">
  </div>
  <p *ngIf="question.type_id==='PARAGRAPH'" [innerHTML]="sanitizedText">
  </p>
  <div
    *ngIf="question.type_id==='AMOUNT' || question.type_id==='attendee_count_estimate' || question.type_id==='client_count_estimate'">
    <input type="text" name="answer_{{nameScope}}{{question.id}}" class="form-control" bkInput [(ngModel)]="answers[question.id]"
      [required]="isFieldRequired">
  </div>
  <div *ngIf="question.type_id==='DATE'">
    <input type="text" name="answer_{{nameScope}}{{question.id}}" [(ngModel)]="answers[question.id]"
      class="form-control datetimepicker" bkInput autocomplete="off" bsDatepicker [required]="isFieldRequired">
  </div>
  <div *ngIf="question.type_id==='FILE'">
    <div *ngIf="answers[question.id]">{{answers[question.id].name}}</div>
    <input type="file" name="answer_{{nameScope}}{{question.id}}" class="dropify" (change)="onFileChange($event)" />
  </div>
  <div *ngIf="isTable">
    <table class="table table-bordered">
      <thead>
        <tr>
          <th *ngIf="rowHeaders.length"></th>
          <th *ngFor="let col of columns">{{col.text}}</th>
          <th width="1%" *ngIf="question.allow_add_rows"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of rows; let r = index">
          <td *ngIf="rowHeaders.length">{{row[ROW_HEADER_KEY]}}</td>
          <td *ngFor="let col of columns">
            <app-question [question]="cellQuestion(col)" [answers]="row" [isCell]="true" [noQuestionText]="true"
              [disabled]="disabled" [required]="isCellRequired(row, col)" [nameScope]="cellNameScope(r)">
            </app-question>
          </td>
          <td *ngIf="question.allow_add_rows">
            <button type="button" class="btn btn-danger btn-sm" *ngIf="canRemoveRow(r)" (click)="removeRow(r)"
              title="Remove">
              <i class="fa fa-trash"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <button type="button" class="btn btn-secondary btn-sm" *ngIf="question.allow_add_rows && !disabled"
      (click)="addRow()">Add Row</button>
  </div>
  <div *ngIf="isTableFile">
    <table class="table table-bordered">
      <thead>
        <tr>
          <th *ngIf="rowHeaders.length"></th>
          <th>File Name</th>
          <th *ngFor="let col of columns">{{col.text}}</th>
          <th width="1%">Remove</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of rows; let r = index">
          <td *ngIf="rowHeaders.length">{{row[ROW_HEADER_KEY]}}</td>
          <td>
            <div class="mb-1" *ngIf="rowFileName(row)">{{rowFileName(row)}}</div>
            <label class="btn btn-secondary btn-sm mb-0" *ngIf="!disabled">
              {{ rowHasFile(row) ? 'Replace File' : 'Upload File' }}
              <input type="file" hidden (change)="onRowFileChange($event, row)">
            </label>
          </td>
          <td *ngFor="let col of columns">
            <app-question [question]="cellQuestion(col)" [answers]="row" [isCell]="true" [noQuestionText]="true"
              [disabled]="disabled" [required]="isCellRequired(row, col)" [nameScope]="cellNameScope(r)">
            </app-question>
          </td>
          <td>
            <button type="button" class="btn btn-danger btn-sm" *ngIf="!disabled" (click)="removeFileRow(r)"
              title="Delete">
              <i class="fa fa-trash"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <label class="btn btn-secondary btn-sm" *ngIf="question.allow_add_rows && !disabled">
      Upload File
      <input type="file" hidden (change)="onUploadNewRow($event)">
    </label>
  </div>
  <div *ngIf="question.other && showOtherField">
    <textarea rows="4" cols="60" name="answer_other_{{nameScope}}{{question.id}}" class="form-control" bkInput
      [(ngModel)]="answers[question.id + '_other']" [required]="isFieldRequired" placeholder="Please specify"></textarea>
  </div>
</div>
<div class="mb-3" *ngIf="question && !isHidden && question.confirm && question.type_id!=='HEADER' && question.type_id!=='PARAGRAPH' && question.type_id!=='CHECKBOX'">
  <label class="form-label">
    <span class="text-danger" *ngIf="answers[question.id]">*</span>Confirm {{question.text}}
  </label>
  <div *ngIf="question.type_id==='TEXT_FIELD' || question.type_id==='PHONE_NUMBER' || question.type_id==='EMAIL' || question.type_id==='TEXT_AREA' || question.type_id==='COMMENTS' || question.type_id==='NUMBER' || question.type_id==='AMOUNT'">
    <input *ngIf="question.type_id!=='TEXT_AREA' && question.type_id!=='COMMENTS'" type="text"
      name="confirm_answer_{{nameScope}}{{question.id}}" class="form-control" bkInput
      [(ngModel)]="answers[question.id + '_confirm']"
      [required]="!!answers[question.id]">
    <textarea *ngIf="question.type_id==='TEXT_AREA' || question.type_id==='COMMENTS'" rows="4" cols="60"
      name="confirm_answer_{{nameScope}}{{question.id}}" class="form-control" bkInput
      [(ngModel)]="answers[question.id + '_confirm']"
      [required]="!!answers[question.id]"></textarea>
  </div>
  <div *ngIf="question.type_id==='DROPDOWN'">
    <select class="form-control" bkInput name="confirm_answer_{{nameScope}}{{question.id}}"
      [(ngModel)]="answers[question.id + '_confirm']"
      [required]="!!answers[question.id]">
      <option [ngValue]="value" *ngFor="let value of choices">{{value}}</option>
    </select>
  </div>
  <div class="text-danger mt-1"
    *ngIf="answers[question.id] && answers[question.id + '_confirm'] && answers[question.id] !== answers[question.id + '_confirm']">
    The responses do NOT match
  </div>
</div>
